export const serviceProcessingRoutes = {
  CLOSE: "close",
};
